'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
export default {
  empty: '',
  validating: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.input.validating"
  }),
  success: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.input.success"
  }),
  error: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.input.error"
  })
};